module.exports = __webpack_public_path__ + "static/media/local-central@2x.bd13cb57.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central@2x.png
// module id = 1177
// module chunks = 2